<template>
  <router-view />
</template>

<style lang="scss">
::-webkit-scrollbar {
  background-color: #14141440;
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #14141460;
  border-radius: 10px;
}
</style>
